import React from "react";
import { Link } from "react-router-dom";
import MyCollectionLayout from "./MyCollectionLayout";
import McBackLink from "./McBackLink";

const HowToScan: React.FC = () => (
  <MyCollectionLayout>
    <McBackLink to="/my-collection/scanned">Back to Scanned</McBackLink>
    <h1 className="h3 mb-2">How to scan</h1>
    <p className="text-muted mb-4">
      Scanned is a receipt of tags you tapped — not a claim that you own the cloth.
    </p>
    <ol className="mc-how-to-scan ps-3">
      <li className="mb-3">
        Hold your phone to the physical HastKalaPramanak NFC tag, or scan the QR printed with the piece.
      </li>
      <li className="mb-3">
        Open the certificate page and verify your phone. That tap is saved to <strong>Scanned</strong> automatically.
      </li>
      <li className="mb-3">
        For about 14 days you can still read what the tag shows. After that, ask the workshop if you need the full certificate again.
      </li>
    </ol>
    <p className="small text-muted mb-0">
      Pieces you add yourself live in{" "}
      <Link to="/my-collection">My pieces</Link>
      . A scan never moves there on its own.
    </p>
  </MyCollectionLayout>
);

export default HowToScan;
